import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { PanAppState } from '@panamax/app-state';
import { Observable } from 'rxjs';
import { FEATURES } from '../../constants/splitio-features';

@Injectable({
  providedIn: 'root',
})
export class ServiceRequestGuardService {
  constructor(private panAppState: PanAppState) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.panAppState.feature$([
      FEATURES.split_global_service_request.name,
    ]);
  }
}
